import React, { useEffect, useState } from "react";
import { Table, Tag, Typography } from "antd";
import { axiosInstant, endpoints } from "../../api";

const { Title } = Typography;

const PLAN_LABELS: Record<string, string> = {
  standerd: "Premium",
  talent_pool: "Talent Pool",
  enterprise: "Enterprise",
  free: "Free Trial",
};

const baseColumns = [
  {
    title: "Date",
    dataIndex: "paidAt",
    key: "paidAt",
    render: (val: number) => (
      <span style={{ fontSize: 16 }}>
        {new Date(val).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
      </span>
    ),
  },
  {
    title: "Plan",
    dataIndex: "plan",
    key: "plan",
    render: (val: string) => <span style={{ fontSize: 16 }}>{PLAN_LABELS[val] || val}</span>,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (val: number) => <span style={{ fontSize: 16 }}>${val}</span>,
  },
  {
    title: "Valid Until",
    dataIndex: "expiresAt",
    key: "expiresAt",
    render: (val: number) => (
      <span style={{ fontSize: 16 }}>
        {new Date(val).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (val: string) => (
      <Tag color={val === "succeeded" ? "green" : "red"} style={{ fontSize: 14, padding: "4px 10px" }}>
        {val.charAt(0).toUpperCase() + val.slice(1)}
      </Tag>
    ),
  },
];

const columns = baseColumns.map((col) => ({
  ...col,
  title: <span style={{ fontSize: 18, fontWeight: 700 }}>{col.title}</span>,
}));

const PaymentHistory = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstant
      .get(endpoints.paymentHistory)
      .then((res) => setRecords(res.data))
      .catch(() => setRecords([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ padding: "32px 40px" }}>
      <Title level={2} style={{ marginBottom: 24 }}>Payment History</Title>
      <Table
        dataSource={records}
        columns={columns}
        rowKey="_id"
        loading={loading}
        bordered
        size="middle"
        pagination={{ pageSize: 10, style: { fontSize: 16 } }}
        locale={{ emptyText: <span style={{ fontSize: 16 }}>No payments yet.</span> }}
        components={{
          body: {
            cell: (props: any) => (
              <td {...props} style={{ ...props.style, fontSize: 16 }} />
            ),
          },
        }}
      />
    </div>
  );
};

export default PaymentHistory;
